import { buttonClasses } from '@components/Button'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

/** 404 — an unknown path in the codex. */
export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <main className="mx-auto max-w-xl px-5 pt-40 pb-24 text-center">
      <div aria-hidden="true" className="font-runic text-3xl text-rune/70">
        {t('notFound.rune')}
      </div>
      <h1 className="mt-4 text-title-grad font-display text-3xl font-bold tracking-wider">
        {t('notFound.title')}
      </h1>
      <p className="mt-3 text-sm/relaxed text-mist/75">{t('notFound.text')}</p>
      <div className="mt-8">
        <Link to="/" className={buttonClasses('ghost')}>
          {t('notFound.back')}
        </Link>
      </div>
    </main>
  )
}
